import { RootState } from '@/app/model/store';

export const selectConditionCodesByKey = (state: RootState) =>
  state.allowedToothConditions.conditionCodesByKey;
